export const PRODUCTION_ASSETS = 'https://www.amorimcorkflooring.com/virtual_tours/assets'
export const DEVELOP_ASSETS = 'https://www.amorimcorkflooring.com/virtual_tours/assets'

export const ASSETS_FOLDER = process.env.REACT_APP_ENVIRONMENT === 'production' ? PRODUCTION_ASSETS: DEVELOP_ASSETS;

export const COLOR = {
  primary: '#BBC3C3',
  secondary: '#1D3739',
  tertiaty: '#2D5A64',
  quaternary: '#AEDBD9',
  quinary: '#112426',
  senary: '#AFAEAE',
}

export const FONT = {
  md: '2.5em',
  md1: '36px',
  md2: '24px',
  md3: '32px',
  sm1: '1.5em',
  sm2: '13px',
  sm3: '21px',
}

export const LINK = {
  linkedin: 'https://www.linkedin.com/company/amorim-cork-flooring/'
}

export const LINKWISE = {
  youtube: 'https://www.youtube.com/channel/UCBQq4l1m60CVtcOxlQ2j9Ow',
  facebook: 'https://www.facebook.com/AmorimFlooring/',
  instagram: 'https://www.instagram.com/amorimwise/',
}

export const LINKWICANDERS = {
  youtube: 'https://www.youtube.com/user/wicanderschannel',
  facebook: 'https://www.facebook.com/wicanders/',
  instagram: 'https://www.instagram.com/wicanders.official/',
}